import { type IDoctorFilters } from '@/app/types/doctorsType'
import { PageWrapper } from '@/shared'
import { Dropdown } from '@/shared/Uikit'
// import { type IDoctorFilters } from '@App/types/doctorsType'

import { DropContent } from './DropContent/DropContent'
import style from './Filter.module.scss'

interface IProps {
    onGetFilteredList: (filterKey: string, opt: string | null) => void
    filters: IDoctorFilters
}

export const Filter = (props: IProps) => {
    const { onGetFilteredList, filters } = props
    const photoOpts = [
        { title: 'Все', value: 'all', locator: 'all-photos' },
        { title: 'Нет', value: 'unhandled', locator: 'empty-photos' },
        { title: 'Есть', value: 'handled', locator: 'photos' }
    ]

    const descriptionsOpts = [
        { title: 'Все', value: 'all', locator: 'all-description' },
        { title: 'Нет', value: 'unhandled', locator: 'empty-description' },
        { title: 'Есть', value: 'handled', locator: 'description' }
    ]
    // const postsOpts = [
    //     { title: 'Все', value: null },
    //     { title: 'Хирург', value: 'Врач-хирург' },
    //     { title: 'Уролог', value: 'Врач-уролог' },
    //     { title: 'Стоматолог', value: 'Врач-стоматолог-терапевт' },
    //     { title: 'Кардиолог', value: 'Врач-кардиолог' }
    // ]

    const onGetChosenFilterTitle = (list: { title: string; value: string | null }[], filter: string | null) =>
        list.find((el) => el.value === filter)?.title || null

    return (
        <PageWrapper>
            <div className={style.container}>
                {/* <div className={style.filterWrapper}>
                    <span className={style.filterTitle}>Специализация</span>
                    <Dropdown
                        className={style.dropWrapper}
                        headerTitle={
                            <div className={style.dropHeaderTitle}>
                                <span>{onGetChosenFilterTitle(postsOpts, filters.post) || 'Специализация'}</span>
                                <Icon iconName={EIcons.AROW} />
                            </div>
                        }
                    >
                        <DropContent list={postsOpts} filterKey='post' onGetFilteredList={onGetFilteredList} />
                    </Dropdown>
                </div> */}
                <div className={style.filterWrapper}>
                    <span className={style.filterTitle}>Фотография</span>
                    <Dropdown
                        childrenStyles={style.children}
                        title={onGetChosenFilterTitle(photoOpts, filters.photo) || 'Фотография'}
                    >
                        <DropContent list={photoOpts} filterKey='photo' onGetFilteredList={onGetFilteredList} />
                    </Dropdown>
                </div>
                <div className={style.filterWrapper}>
                    <span className={style.filterTitle}>Описание</span>
                    <Dropdown
                        childrenStyles={style.children}
                        title={onGetChosenFilterTitle(descriptionsOpts, filters.description) || 'Описание'}
                    >
                        <DropContent
                            list={descriptionsOpts}
                            filterKey='description'
                            onGetFilteredList={onGetFilteredList}
                        />
                    </Dropdown>
                </div>
            </div>
        </PageWrapper>
    )
}
